import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["children"];
var StyledDialogActions = styled.div.withConfig({
  displayName: "DialogActions__StyledDialogActions",
  componentId: "sc-16ydtxd-0"
})(function (_ref) {
  var theme = _ref.theme,
    children = _ref.children;
  return css(["align-self:end;justify-self:start;padding:0 ", " 0 ", ";&:first-child{padding-top:", ";}&:last-child{padding-bottom:", ";}", ""], theme.entities.children.spacings.right, theme.entities.children.spacings.left, theme.entities.children.spacings.top, theme.entities.children.spacings.bottom, !children && css(["min-height:initial;height:'8px';"]));
});
var DialogActions = /*#__PURE__*/forwardRef(function DialogActions(_ref2, ref) {
  var children = _ref2.children,
    props = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/jsx(StyledDialogActions, _objectSpread(_objectSpread({
    ref: ref
  }, props), {}, {
    children: children
  }));
});

// Actions.displayName = 'EdsDialogActions'

export { DialogActions };
